import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <p className="text-center mt-1 fw-bold">
        Sydney Kart - 2025, All Rights Reserved &copy;
      </p>
    </footer>
  );
};

export default Footer;
